import { Button, Col, Collapse, Container, Navbar, NavbarToggler } from "reactstrap";
import React, { useState } from "react";
import dynamic from "next/dynamic";
import BackButton from "../../../BackButton";
import Menu from "../../Mobile/Menu";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var MobileCottageSearchModal = dynamic(function () {
  return import('../../../CottageSearch/MobileCottageSearchModal');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('../../../CottageSearch/MobileCottageSearchModal')];
    },
    modules: ["../components/Header/CottageSearch/Mobile/Index.js -> " + '../../../CottageSearch/MobileCottageSearchModal']
  }
});

var Index = function Index(props) {
  var _useState = useState(false),
      modal = _useState[0],
      setModal = _useState[1];

  var _useState2 = useState(false),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var toggleModal = function toggleModal() {
    return setModal(!modal);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("header", {
      className: "header ".concat(props.headerClasses ? props.headerClasses : ""),
      children: /*#__PURE__*/_jsx(Navbar, {
        color: "white",
        light: true,
        dark: false,
        fixed: "top",
        expand: "lg",
        className: props.nav.classes ? props.nav.classes : "",
        children: /*#__PURE__*/_jsxs(Container, {
          fluid: true,
          children: [/*#__PURE__*/_jsx(Col, {
            xs: 2,
            className: "text-left pl-0",
            children: /*#__PURE__*/_jsx(BackButton, {})
          }), /*#__PURE__*/_jsx(Col, {
            xs: 8,
            className: "text-center mobile-cottage-search-menu",
            children: /*#__PURE__*/_jsxs(Button, {
              className: "font-weight-bold",
              size: "sm",
              onClick: function onClick() {
                return toggleModal();
              },
              color: "light",
              children: [/*#__PURE__*/_jsx("i", {
                className: "fas fa-search mobile-cottage-search-menu-icon text-primary"
              }), "Wijzig zoekopdracht"]
            })
          }), /*#__PURE__*/_jsxs(Col, {
            xs: 2,
            children: [/*#__PURE__*/_jsx(NavbarToggler, {
              onClick: function onClick() {
                return setCollapsed(!collapsed);
              },
              className: "navbar-toggler-right",
              children: /*#__PURE__*/_jsx("i", {
                className: "fa fa-bars"
              })
            }), /*#__PURE__*/_jsx(Collapse, {
              isOpen: collapsed,
              className: "offcanvas-collapse",
              children: /*#__PURE__*/_jsx(Menu, {
                onMenuClick: function onMenuClick() {
                  return setCollapsed(false);
                }
              })
            })]
          })]
        })
      })
    }), modal && /*#__PURE__*/_jsx(MobileCottageSearchModal, {
      isOpen: modal,
      toggle: function toggle() {
        return toggleModal();
      }
    })]
  });
};

export default Index;